import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';
import { RightOutlined } from '@ant-design/icons';

import { safeKeyPress } from '@utils/accessibility';

const WRAPPER_STYLE = {
  marginTop: 40,
  position: 'relative',
  textAlign: 'center'
};

const PRIVACY_WRAPPER_STYLE = {
  color: '#c0c0c0',
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.6
};

const SKIP_STYLE = {
  bottom: 4,
  color: '#000', // $theme-text-color
  cursor: 'pointer',
  fontSize: 12,
  fontWeight: 600,
  position: 'absolute',
  right: 0
};

const PRIVACY_URL = 'https://arkestro.com/privacy-policy';
const TERMS_URL = 'https://arkestro.com/terms-of-use';

const Footer = ({ showPrivacyTerms = true, onSkip }) => {
  const { t } = useTranslation('common');
  const handleSkip = () => {
    if (onSkip) onSkip();
  };

  return (
    <div style={WRAPPER_STYLE}>
      {showPrivacyTerms && (
        <div style={PRIVACY_WRAPPER_STYLE}>
          <a href={PRIVACY_URL} rel='noopener noreferrer' style={{ color: '#c0c0c0' }} target='_blank'>
            {t('general.privacy_policy')}
          </a>
          <span>  |  </span>
          <a href={TERMS_URL} rel='noopener noreferrer' style={{ color: '#c0c0c0' }} target='_blank'>
            {t('general.terms_of_use')}
          </a>
        </div>
      )}
      {onSkip && (
        <div
          onClick={handleSkip}
          onKeyPress={e => safeKeyPress(e, handleSkip)}
          role='button'
          style={SKIP_STYLE}
          tabIndex={0}
        >
          {t('general.capitalized.skip')}
          <RightOutlined style={{ fontSize: 12, marginLeft: 10 }} />
        </div>
      )}
    </div>
  );
};

Footer.propTypes = {
  onSkip: PropTypes.func,
  showPrivacyTerms: PropTypes.bool
};

export default Footer;
